import { Box, Typography, Stack } from "@mui/material";
import svgPaths from "../assets/images/svg-p2f939vg7m";
import { LogoSales } from '../assets/images'

function Frame2147208051() {
  return (
    <Box
      sx={{
        bgcolor: "#007bff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: "12px",
        py: "2.791px",
        borderRadius: "22px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 600,
          fontSize: { xs: "16px", sm: "18px" },
          color: "white",
          textAlign: "center",
          whiteSpace: "pre",
          letterSpacing: "0.2453px",
        }}
      >
        Live + Automated
      </Typography>
    </Box>
  );
}

function Frame2147208052() {
  return (
    <Box
      sx={{
        bgcolor: "#e6a116",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: "12px",
        py: "2.791px",
        borderRadius: "22px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 600,
          fontSize: { xs: "16px", sm: "18px" },
          color: "white",
          textAlign: "center",
          whiteSpace: "pre",
          letterSpacing: "0.2453px",
        }}
      >
        Annual
      </Typography>
    </Box>
  );
}

function Frame2147208158() {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      flexWrap="wrap"
      justifyContent="center"
      sx={{ width: "100%" }}
    >
      <Frame2147208051 />
      <Frame2147208052 />
    </Stack>
  );
}

function Frame2147208053() {
  return (
    <Stack spacing={3} sx={{ width: "100%" }}>
      <Frame2147208158 />
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 700,
          fontSize: { xs: "30px", sm: "40px" },
          color: "black",
          textAlign: "left",
          whiteSpace: "pre",
          letterSpacing: "0.2453px",
          lineHeight: "34.192px",
        }}
      >
        Professional
      </Typography>
    </Stack>
  );
}

function Frame2147208045() {
  return (
    <Stack spacing={3} sx={{ width: "100%" }}>
      <Frame2147208053 />
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 500,
          fontSize: "14px",
          color: "black",
          letterSpacing: "-0.3135px",
          lineHeight: "25px",
        }}
      >
        The all-in-one solution for running both live and automated webinars.
      </Typography>
    </Stack>
  );
}

function Frame2147208047() {
  return (
    <Box
      sx={{
        bgcolor: "white",
        display: "flex",
        flexDirection: "column",
        gap: "16.747px",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 3, sm: "24.423px" },
        py: "24px",
        borderRadius: "16.747px",
        border: "0.698px solid #ddddfe",
        width: "100%",
        maxWidth: "368px",
      }}
    >
      <Frame2147208045 />
    </Box>
  );
}

function Container1() {
  return (
    <Box>
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 700,
          fontSize: { xs: "20px", sm: "24px" },
          color: "black",
          letterSpacing: "0.0696px",
        }}
      >
        3000/month
      </Typography>
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 500,
          fontSize: { xs: "12px", sm: "14px" },
          color: "black",
          opacity: 0.7,
          letterSpacing: "0.0491px",
          lineHeight: "22.33px",
        }}
      >
        500 Live + 2,500 Automated Attendees
      </Typography>
    </Box>
  );
}

function Container2() {
  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Container1 />
    </Stack>
  );
}

function Container3() {
  return (
    <Box
      sx={{
        bgcolor: "white",
        display: "flex",
        flexDirection: "column",
        gap: 3,
        p: 3,
        borderRadius: "16.747px",
        border: "0.698px solid #ddddfe",
        width: "100%",
        maxWidth: "368px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 700,
          fontSize: { xs: "18px", sm: "24px" },
          color: "black",
          textAlign: "left",
          letterSpacing: "0.0676px",
          lineHeight: "30.765px",
        }}
      >
        Attendees
      </Typography>
      <Container2 />
    </Box>
  );
}

function Badge() {
  return (
    <Box
      sx={{
        bgcolor: "black",
        borderRadius: "999px",
        px: 2,
        py: 1,
        border: "1.03px solid transparent",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 500,
          fontSize: { xs: "16px", sm: "20.671px" },
          color: "white",
          whiteSpace: "pre",
          letterSpacing: "-0.4528px",
          lineHeight: "28.849px",
        }}
      >
        {` ️ Save $712/year`}
      </Typography>
    </Box>
  );
}

function Container4() {
  return (
    <Stack
      direction="row"
      spacing={2.5}
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
    >
      <Typography
        sx={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 400,
          fontSize: { xs: "30px", sm: "38px" },
          color: "black",
          textDecoration: "line-through",
          opacity: 0.6,
          letterSpacing: "0.064px",
          lineHeight: "37.441px",
        }}
      >
        $198
      </Typography>
      <Box>
        <Typography
          sx={{
            fontFamily: "'Inter', sans-serif",
            fontWeight: 700,
          }}
        >
          <Box
            component="span"
            sx={{
              fontSize: { xs: "36px", sm: "48px" },
              lineHeight: "48.493px",
              color: "black",
            }}
          >
            $139
          </Box>
          <Box
            component="span"
            sx={{
              fontSize: { xs: "18px", sm: "20px" },
              lineHeight: "40px",
              color: "black",
            }}
          >
            {" "}
            /month
          </Box>
        </Typography>
      </Box>
    </Stack>
  );
}

function Frame2147208042() {
  return (
    <Stack spacing={3.5} alignItems="center" sx={{ py: 3, width: "100%" }}>
      <Badge />
      <Container4 />
    </Stack>
  );
}

function Frame2147208048() {
  return (
    <Box
      sx={{
        bgcolor: "white",
        display: "flex",
        flexDirection: "column",
        gap: 3.5,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "16.747px",
        border: "0.698px solid #ddddfe",
        width: "100%",
        maxWidth: "368px",
      }}
    >
      <Frame2147208042 />
    </Box>
  );
}

function Frame2147208046() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{ width: { xs: "100%", lg: "auto" } }}
    >
      <Frame2147208047 />
      <Container3 />
      <Frame2147208048 />
    </Stack>
  );
}

function Icon() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p3bb5b5c0}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      4-hour live sessions
    </Typography>
  );
}

function Container5() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon />
      <Text />
    </Stack>
  );
}

function Icon1() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p3bb5b5c0}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text1() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      Up to 5 active webinars
    </Typography>
  );
}

function Container6() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon1 />
      <Text1 />
    </Stack>
  );
}

function Icon2() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p1fc97840}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text2() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      {`Simulive, On-Demand & Evergreen`}
    </Typography>
  );
}

function Container7() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon2 />
      <Text2 />
    </Stack>
  );
}

function Icon3() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p201f54c0}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text3() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      Stream to YouTube or via RTMP
    </Typography>
  );
}

function Container8() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon3 />
      <Text3 />
    </Stack>
  );
}

function Icon4() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p369a91c0}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text4() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      Simulated + live chat support
    </Typography>
  );
}

function Container9() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon4 />
      <Text4 />
    </Stack>
  );
}

function Icon5() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p27a840}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text5() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      Up to 3 co-hosts
    </Typography>
  );
}

function Container10() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon5 />
      <Text5 />
    </Stack>
  );
}

function Icon6() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p1bcc8480}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text6() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      {`Advanced analytics & reporting`}
    </Typography>
  );
}

function Container11() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon6 />
      <Text6 />
    </Stack>
  );
}

function Icon7() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p2df57d00}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text7() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      4 GB storage included
    </Typography>
  );
}

function Container12() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon7 />
      <Text7 />
    </Stack>
  );
}

function Icon8() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p36bcb380}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text8() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      {`Priority support & manager`}
    </Typography>
  );
}

function Container13() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon8 />
      <Text8 />
    </Stack>
  );
}

function Icon9() {
  return (
    <Box sx={{ width: "13.956px", height: "13.956px", flexShrink: 0 }}>
      <svg
        style={{ display: "block", width: "100%", height: "100%" }}
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 14 14"
      >
        <g id="Icon">
          <path
            d={svgPaths.p38a0baa0}
            id="Vector"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.16301"
          />
        </g>
      </svg>
    </Box>
  );
}

function Text9() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        fontSize: { xs: "14px", sm: "16px" },
        color: "black",
        letterSpacing: "-0.3067px",
        lineHeight: "19.539px",
      }}
    >
      All enterprise level integrations
    </Typography>
  );
}

function Container14() {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ width: "100%" }}>
      <Icon9 />
      <Text9 />
    </Stack>
  );
}

function Container15() {
  return (
    <Stack spacing={2.5} sx={{ width: "100%" }}>
      <Container5 />
      <Container6 />
      <Container7 />
      <Container8 />
      <Container9 />
      <Container10 />
      <Container11 />
      <Container12 />
      <Container13 />
      <Container14 />
    </Stack>
  );
}

function Heading3() {
  return (
    <Typography
      sx={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 700,
        fontSize: { xs: "20px", sm: "24px" },
        color: "black",
        letterSpacing: "0.0491px",
        lineHeight: "22.33px",
      }}
    >
      {`What's Included`}
    </Typography>
  );
}

function Frame2147208157() {
  return (
    <Stack spacing={3} sx={{ width: "100%" }}>
      <Heading3 />
      <Container15 />
    </Stack>
  );
}

// Combined Logos Row 1 - Replace src with your combined logo image URL
function Frame2147208059() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        py: 1,
      }}
    >
      <Box
        component="img"
        alt="Partner Logos"
        src={LogoSales}
        sx={{
          maxWidth: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />
    </Box>
  );
}


function Frame2147208057() {
  return (
    <Stack spacing={0} alignItems="center" justifyContent="center" sx={{ width: "100%" }}>
      <Frame2147208059 />
      {/* <Frame2147208058 /> */}
    </Stack>
  );
}

function Container16() {
  return (
    <Box
      sx={{
        bgcolor: "white",
        display: "flex",
        flexDirection: "column",
        gap: 4,
        minHeight: "582px",
        pb: 0,
        pt: 3,
        px: 3,
        borderRadius: "16.747px",
        border: "0.698px solid #ddddfe",
        width: { xs: "100%", lg: "auto" },
        minWidth: { lg: "343px" },
      }}
    >
      <Frame2147208157 />
      <Frame2147208057 />
    </Box>
  );
}

export default function Frame2147208043() {
  return (
    <Stack
      direction={{ xs: "column", lg: "row" }}
      spacing={3}
      alignItems="flex-start"
      justifyContent="center"
      sx={{ width: "100%" }}
    >
      <Frame2147208046 />
      <Container16 />
    </Stack>
  );
}
